export const API_ROUTE = "/api"

export const DASHBOARD_ROUTE = "/dashboard"
